import { render } from "./BoardArray.vue?vue&type=template&id=6b86d250"
import script from "./BoardArray.vue?vue&type=script&lang=js"
export * from "./BoardArray.vue?vue&type=script&lang=js"

import "./BoardArray.vue?vue&type=style&index=0&id=6b86d250&lang=css"

import exportComponent from "/home/hadams/code/Vuejs_Wordle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__